<template>
<div>
  <p class="h3">Informationen</p>

  <div class="row">
    <div class="col-sm-24">
      <contact-input name="objectnr" label="Objekt Nummer" group="contact"></contact-input>
    </div>

    <div class="col-sm-24">
      <contact-input name="einheitennr" label="Einheiten-Nr" group="contact"></contact-input>
    </div>
  </div>

  <p class="h3">Kaltwasserzähler</p>

  <div class="row">
    <div class="col-sm-8">
      <contact-input name="wohnung" label="Wohnung" group="contact"></contact-input>
    </div>

    <div class="col-sm-8">
      <contact-input name="bad" label="Bad" group="contact"></contact-input>
    </div>

    <div class="col-sm-8">
      <contact-input name="abstellraum-flur" label="Abstellraum/Flur" group="contact"></contact-input>
    </div>
  </div>

  <div class="row">
    <div class="col-sm-12">
      <contact-input name="waschmaschine" label="Waschmaschine" group="contact"></contact-input>
    </div>

    <div class="col-sm-12">
      <contact-input name="kellerraum" label="Kellerraum" group="contact"></contact-input>
    </div>
  </div>

  <div class="row">
    <div class="col-sm-12">
      <contact-input name="warmwasser" label="Warmwasser" group="contact"></contact-input>
    </div>

    <div class="col-sm-12">
      <contact-input name="waermezaehler" label="Wärmezähler" group="contact"></contact-input>
    </div>
  </div>

  <p class="h3">Personenzahl des abgelaufenen Kalerderjahrs</p>

  <div class="row">
    <div class="col-sm-24">
      <p>Zeitraum 1</p>
    </div>

    <div class="col-sm-8">
      <contact-input name="zeitraum-1-von" label="von" group="contact"></contact-input>
    </div>

    <div class="col-sm-8">
      <contact-input name="zeitraum-1-bis" label="bis" group="contact"></contact-input>
    </div>

    <div class="col-sm-8">
      <contact-input name="zeitraum-1-personen" label="Personen" group="contact"></contact-input>
    </div>
  </div>

  <div class="row">
    <div class="col-sm-24">
      <p>Zeitraum 2</p>
    </div>

    <div class="col-sm-8">
      <contact-input name="zeitraum-2-von" label="von" group="contact"></contact-input>
    </div>

    <div class="col-sm-8">
      <contact-input name="zeitraum-2-bis" label="bis" group="contact"></contact-input>
    </div>

    <div class="col-sm-8">
      <contact-input name="zeitraum-2-personen" label="Personen" group="contact"></contact-input>
    </div>
  </div>

  <p class="h3">Kontakt Informationen</p>

  <div class="row">
    <div class="col-sm-8">
      <contact-select name="salutation" label="Anrede" group="contact" values="Frau,Herr" placeholder="Anrede"></contact-select>
    </div>
    <div class="col-sm-8">
      <contact-input name="firstname" label="Vorname" group="contact"></contact-input>
    </div>
    <div class="col-sm-8">
      <contact-input name="lastname" label="Nachname" group="contact"></contact-input>
    </div>
  </div>

  <div class="row">
    <div class="col-sm-12">
      <contact-input name="phone" label="Telefon" group="contact"></contact-input>
    </div>
    <div class="col-sm-12">
      <contact-input name="email" label="E-Mail" group="contact"></contact-input>
    </div>
  </div>

  <div class="row">
    <div class="col-sm-24">
      <contact-input  textarea label="Nachricht" name="message" group="contact"></contact-input>
    </div>
  </div>
</div>
</template>

<script>
import ContactInput from "./ContactInput.vue";
import ContactSelect from "./ContactSelect.vue";

export default {
  name: "ZaehlerstandFields",

  components: {
    ContactInput,
    ContactSelect
  },

  props: {
    include: {
      type: Array,
      default: () => []
    },
    exclude: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      contactType: []
    };
  },

  computed: {
    fields() {
      if (!this.include) {
        return [];
      }

      return [...this.include];
    }
  },

  mounted() {
    this.$root.contactForm.registerField(this);
  },

  beforeDestroy() {
    this.$root.contactForm.unregisterField(this);
  },

  methods: {
    mapValue() {
      this.$root.contactForm.contact.contactType = this.contactType;
    }
  }
};
</script>
